import { render, staticRenderFns } from "./EpsCard.vue?vue&type=template&id=10cecedd&scoped=true&"
import script from "./EpsCard.js?vue&type=script&lang=js&"
export * from "./EpsCard.js?vue&type=script&lang=js&"
import style0 from "./EpsCard.scss?vue&type=style&index=0&id=10cecedd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cecedd",
  null
  
)

export default component.exports